import { SITE_NAME } from '../../../../../../config/environment';

const adaptData = ({ data, searchQuery }) => {
    const { title } = data;

    const descriptionMeta = {
        name: 'description',
        content: `${title} Sitemap - ${SITE_NAME}`
    };

    return {
        title: `${title} Sitemap - ${SITE_NAME}`,
        meta: [descriptionMeta]
    }
}

export default adaptData;
